import type { EditorCommand } from '@atlaskit/editor-common/types';
import { NodeSelection } from '@atlaskit/editor-prosemirror/state';

import { malleableUiPluginKey } from '../pm-plugins/plugin-key';

export const openRemixModal =
	(nodePos?: number): EditorCommand =>
	({ tr }) => {
		if (nodePos !== undefined) {
			tr.setSelection(NodeSelection.create(tr.doc, nodePos));
		}
		tr.setMeta(malleableUiPluginKey, { isRemixModalOpen: true });
		return tr;
	};
